export default "__VITE_ASSET__7e5e919a__"